module.exports = __webpack_public_path__ + "img/vertical_4_6_6005.c96c981b.png";